import React from 'react';
import DogDisplayPage from './DogDisplayPage';
import { WidePhoto, TallPhoto, SquarePhoto } from './Constants';
import storm1 from './assets/images/storm/storm1.jpg';
import storm2 from './assets/images/storm/storm2.jpg';
import storm3 from './assets/images/storm/storm3.jpg';
import storm4 from './assets/images/storm/storm4.jpg';
import storm5 from './assets/images/storm/storm5.jpg';
import storm6 from './assets/images/storm/storm6.jpg';
import storm7 from './assets/images/storm/storm7.jpg';
import storm8 from './assets/images/storm/storm8.jpg';
import storm9 from './assets/images/storm/storm9.jpg';
import storm10 from './assets/images/storm/storm10.jpg';
import storm11 from './assets/images/storm/storm11.png';
import storm12 from './assets/images/storm/storm12.jpg';
import storm13 from './assets/images/storm/storm13.jpg';
import storm14 from './assets/images/storm/storm14.jpg';
import storm15 from './assets/images/storm/storm15.jpg';
import storm16 from './assets/images/storm/storm16.jpg';
import storm17 from './assets/images/storm/storm17.jpg';
import storm18 from './assets/images/storm/storm18.jpg';

const photos = [
    { src: storm1, ...SquarePhoto },
    { src: storm2, ...WidePhoto },
    { src: storm3, ...WidePhoto },
    { src: storm4, ...TallPhoto },
    { src: storm5, ...SquarePhoto },
    { src: storm6, ...TallPhoto },
    { src: storm7, ...TallPhoto },
    { src: storm8, ...TallPhoto },
    { src: storm9, ...TallPhoto },
    { src: storm10, ...TallPhoto },
    { src: storm11, ...TallPhoto },
    { src: storm12, ...TallPhoto },
    { src: storm13, ...TallPhoto },
    { src: storm14, ...WidePhoto },
    { src: storm15, ...WidePhoto },
    { src: storm16, ...WidePhoto },
    { src: storm17, ...TallPhoto },
    { src: storm18, ...TallPhoto }
];

const Ariel = () => {
    return (
        <DogDisplayPage photos={photos}>
            <h1 className="male">
                <i className="far fa-venus"></i>
                Storm
            </h1>
            <table className="dog-chart">
                <tbody>
                    <tr>
                        <td><span className="title">Name</span>ch LUNANOVA silverspring SWIRLING storm</td>
                        <td><span className="title">Owner</span>CAROLYNNE ISSA / JOANNE SKALOS</td>
                        <td><span className="title">CKC Registration</span>#KE4174184</td>
                    </tr>
                    <tr>
                        <td><span className="title">Sire</span>GCHB downeast drewsar kwik hitter</td>
                        <td><span className="title">Dam</span>CH LUNANOVA let the storm rage on</td>
                    </tr>
                    <tr>
                        <td><span className="title">Coat Type</span>Wavy</td>
                        <td><span className="title">Coat Colour</span>BLACK WITH WHITE MARKINGS</td>
                    </tr>
                    <tr>
                        <td><span className="title">CAER</span>NORMAL</td>
                        <td><span className="title">CDDY/IVVD</span>NORMAL</td>
                        <td><span className="title">EOPRA</span>NORMAL</td>
                    </tr>
                    <tr>
                        <td><span className="title">GM-1</span>normal</td>
                        <td><span className="title">Improper Coat</span>normal</td>
                        <td><span className="title">JDCM</span>normal</td>
                        <td><span className="title">MICROPHTHALMIA SYNDROME</span>normal</td>
                    </tr>
                    <tr>
                        <td><span className="title">OFA Hips</span>GOOD (ELBOWS NORMAL)	</td>
                        <td><span className="title">PRA</span>normal</td>
                    </tr>
                </tbody>
            </table>
        </DogDisplayPage>
    )
}
export default Ariel;
